import http from "@/utils/request";

const auth = {
  login: (data) =>
    http.sendRequest({
      METHOD_NAME: "user.webLogin",
      SECURITY_TYPE: "None",
      data,
      ERROR_CODE: {
        1000010: "用户名或密码错误",
        1000030: "用户名或密码错误",
        1000100: "图片验证码错误",
        1000110: "账户尚未激活",
        1000300: "用户名或密码错误已达3次",
        1000340: "用户账户还没有密码",
        1000480: "用户账户被冻结，不允许登录",
      },
    }),
  authPinduoduoCode: (code) =>
    http.sendRequest({
      METHOD_NAME: "pinduoduo.authByCode",
      SECURITY_TYPE: "None",
      data: {
        code,
        pati: localStorage.getItem("pdd_pati"),
        pageCode: localStorage.getItem("pdd_pageCode"),
      },
      ERROR_CODE: {},
    }),
  getIsvPageCode: (httpReferer) =>
    http.sendRequest({
      METHOD_NAME: "pinduoduo.getIsvPageCode",
      SECURITY_TYPE: "None",
      data: {
        httpReferer,
      },
      ERROR_CODE: {},
    }),
  authDouYinCode: (code) =>
    http.sendRequest({
      METHOD_NAME: "douYin.auth",
      SECURITY_TYPE: "None",
      data: {
        code,
      },
      ERROR_CODE: {},
    }),
  authJDCode: (code) =>
    http.sendRequest({
      METHOD_NAME: "jd.authByCode",
      SECURITY_TYPE: "None",
      data: {
        code,
      },
      ERROR_CODE: {},
    }),
  getUserInfo: () =>
    http.sendRequest({
      METHOD_NAME: "user.getUserInfo",
      SECURITY_TYPE: "UserLogin",
    }),
  getOmsUserInfo: () =>
    http.sendRequest({
      METHOD_NAME: "customsDeclare.loadOmsUserInfo",
      SECURITY_TYPE: "UserLogin",
    }),
  changePassword: (data) =>
    http.sendRequest({
      METHOD_NAME: "user.changePassword",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  // 更新密码
  changePasswordDirect: (data) =>
    http.sendRequest({
      METHOD_NAME: "user.changePasswordDirect",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {
        1000010: "用户名或密码错误",
        1000040: "原密码错误",
        1000060: "密码与原密码相同",
      },
    }),
  // 更新密码验证短信
  checkMsgForUpdatePassword: (data) =>
    http.sendRequest({
      METHOD_NAME: "venderUserService.checkMsgForUpdatePassword",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  // 更新密码发送短信
  sendMsgForUpdatePassword: (data) =>
    http.sendRequest({
      METHOD_NAME: "venderUserService.sendMsgForUpdatePassword",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  // 查询供应商合作类型
  queryProviderCopType: (data) =>
    http.sendRequest({
      METHOD_NAME: "venderUserService.queryProviderCopType",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  getVfCode: (data) =>
    http.sendRequest({
      METHOD_NAME: "user.getVfCode",
      SECURITY_TYPE: "None",
      data,
      ERROR_CODE: {},
    }),
};

export default auth;
